export const appConfig = {
  baseUrl: process.env.NEXT_PUBLIC_BASE_URL
};
